import React from 'react'

export const Title = props => <h1 className="text-center text-3xl" {...props} />
